'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RetryError = function (_Error) {
  _inherits(RetryError, _Error);

  function RetryError() {
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, RetryError);

    var _this = _possibleConstructorReturn(this, (RetryError.__proto__ || Object.getPrototypeOf(RetryError)).call(this, 'RetryError'));

    _this.errors = errors;
    return _this;
  }

  return RetryError;
}(Error);

/**
 * Retries a promise n times. When a retry exceeds the max retry times this function
 * throws a Retry error. This error has a property `errors` which is an array containing
 * all errors thrown.
 * @param {number} times the number of retries until the promise fails
 * @returns {function}
 * @example
 * import { retry } from 'promise-frites';
 *
 * const error = new Error('API example error');
 * const apiCall = () => { throw error };
 * const retry3Times = retry(3);
 * Promise.resolve()
 *  .then(retry3Times(apiCall))
 *  .then((value) => console.log(value))
 *  .catch((retryError) => {
 *    console.log(retryError.errors[0] === error); // true
 *    console.log(retryError.errors[1] === error); // true
 *    console.log(retryError.errors[2] === error); // true
 *  });
 */


var retry = exports.retry = function retry(times) {
  return function (fn) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new Promise(function (resolve, reject) {
        var _retry = function _retry(remainingTries) {
          var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          if (remainingTries <= 0) {
            return reject(new RetryError(errors));
          }

          Promise.resolve().then(function () {
            return fn.apply(undefined, args);
          }).then(resolve).catch(function (error) {
            return _retry(remainingTries - 1, [].concat(_toConsumableArray(errors), [error]));
          });
        };

        _retry(times);
      });
    };
  };
};